var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6642 1.53631C15.6642 0.864312 15.1202 0.320312 14.4482 0.320312H1.5202C0.8482 0.320312 0.304199 0.864312 0.304199 1.53631L0.3202 11.5843C0.3202 12.2563 0.864201 12.8003 1.5362 12.8003H5.7602L7.3762 15.3603C7.6482 15.7923 8.2882 15.7923 8.5602 15.3603L10.2242 12.8003H14.4642C15.1362 12.8003 15.6802 12.2563 15.6802 11.5843L15.6642 1.53631ZM9.5842 8.48031C9.5842 8.78431 9.3442 9.02431 9.04021 9.02431H4.3042C4.0002 9.02431 3.7602 8.78431 3.7602 8.48031C3.7602 8.17631 4.0002 7.93631 4.3042 7.93631H9.04021C9.3442 7.93631 9.5842 8.19231 9.5842 8.48031ZM11.6962 6.89631H4.3042C4.0002 6.89631 3.7602 6.65631 3.7602 6.35231C3.7602 6.04831 4.0002 5.80831 4.3042 5.80831H11.6962C12.0002 5.80831 12.2402 6.04831 12.2402 6.35231C12.2402 6.64031 12.0002 6.89631 11.6962 6.89631ZM11.6962 4.75231H4.3042C4.0002 4.75231 3.7602 4.51231 3.7602 4.20831C3.7602 3.90431 4.0002 3.66431 4.3042 3.66431H11.6962C12.0002 3.66431 12.2402 3.90431 12.2402 4.20831C12.2402 4.51231 12.0002 4.75231 11.6962 4.75231Z",
    fill: "#ACBED2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.943714eea348bd0aeab9857493389a02.svg";
export { ForwardRef as ReactComponent };